const reasons = [
  {
    icon: "ri-map-pin-2-line",
    title: "Une vraie entreprise locale",
    desc: "Notre atelier Strasbourg est situé au 82 Rue de Heidenberg. Pas de centrale anonyme. Vous nous appelez, nous venons.",
  },
  {
    icon: "ri-recycle-line",
    title: "Réparer plutôt que remplacer",
    desc: "Nous privilégions toujours la solution la plus économique pour vous. La réparation est notre métier.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Toutes marques",
    desc: "Somfy, Nice, Simu, Bubendorff, Profalux… Nous réparons tous les volets roulants, sans exception.",
  },
  {
    icon: "ri-file-list-3-line",
    title: "Devis clair et gratuit",
    desc: "Aucun frais caché. Le diagnostic et le déplacement sont gratuits, le devis est transparent.",
  },
];

export default function PourquoiNous() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold text-center mb-10 md:mb-14">
          Pourquoi nous faire <strong className="text-brand-blue">confiance</strong> ?
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {reasons.map((r) => (
            <div key={r.title} className="text-center">
              <div className="w-14 h-14 flex items-center justify-center rounded-full border-2 border-brand-blue/20 mx-auto mb-4">
                <i className={`${r.icon} text-brand-blue text-2xl`}></i>
              </div>
              <h3 className="text-brand-blue text-base font-bold mb-2">{r.title}</h3>
              <p className="text-brand-text text-sm leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}